import axios from 'axios';

//import * as fs from 'node:fs';

// const API_URL = 'http://szlsxiaowu.cn:3000/api';
const API_URL = 'https://www.szlsxiaowu.cn:3000/api';
//用户注册
export const register = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/register`, {
      username:username,
      password:password
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during registration:', error);
    throw error;
  }
};
//用户登录
export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {
      username: username,
      password: password
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
};
//用户修改密码
export const changePassword = async (username, old_password, new_password) => {
  try {
    const response = await axios.post(`${API_URL}/change_password`, {
      username: username,
      old_password: old_password,
      new_password: new_password
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during change password:', error);
    throw error;
  }
}
//创建聊天
export const createChat = async (user_id, title,scene) => {
  try {
    const response = await axios.post(`${API_URL}/create_chat`, {
      user_id: user_id,
      title: title,
      scene: scene
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during create chat:', error);
    throw error;
  }
}
//获取聊天列表
export const getChatList = async (user_id) => {
  try {
    const response = await axios.get(`${API_URL}/chat_list`, {
      params: { user_id: user_id }
    });
    console.log('Response:', response);
    return response.data.chats;
  } catch (error) {
    console.error('Error during get chat list:', error);
    throw error;
  }
}
// 删除聊天记录
export const deleteChat = async (user_id,chat_id) => {
  try {
    const response = await axios.post(`${API_URL}/delete_chat`, {     
      user_id: user_id,
      chat_id: chat_id
    });
    //console.log('删除响应:', response);
    return response.data;
  } catch (error) {
    console.error('Error during delete chat:', error);
    throw error;
  }
}
//更新聊天记录标题
export const updateChatTitle = async (user_id,chat_id, new_title) => {
  try {
    const response = await axios.post(`${API_URL}/update_chat_title`, {
      user_id: user_id,
      chat_id: chat_id,
      new_title: new_title
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during update chat title:', error);
    throw error;
  }
}
// 发送用户消息，并返回用户消息和AI回复
export const sendMessage = async (user_id, chat_id, user_message,ai_message,usertimestamp,aitimestamp,vote) => {
  try {
    const response = await axios.post(`${API_URL}/send_message`, {
      user_id: user_id,
      chat_id: chat_id,
      user_message: user_message,
      ai_message:ai_message,
      usertimestamp:usertimestamp,
      aitimestamp:aitimestamp,
      vote:vote
    });
    return response.data;
  } catch (error) {
    console.error('Error during send user message:', error);
    throw error;
  }
};
//发送用户消息，并返回用户消息和AI回复,实现流式输出
export const getAIResponse = async (message) => {
  try {
    const response = await axios.post(`${API_URL}/get_ai_response`, { message}); 
    //console.log('Response:', response);
    return response.data; 
  } catch (error) {
    console.error('Error during get AI response:', error);
    throw error;
  }
};
//获取Agent回复
export const getAgentResponse = async (message,chat_history,user_id,ifUseKnowldgeBase,ifUseWeb) => {
  try {
    const response = await axios.post(`${API_URL}/get_agent_response`, { 
      message: message,
      chat_history: chat_history,
      user_id: user_id,
      ifUseKnowldgeBase: ifUseKnowldgeBase,
      ifUseWeb: ifUseWeb
     });
//console.log('Response:', response);
  return response.data; 
  } catch (error) {
    console.error('Error during get Agent response:', error);
    throw error;
  }
};
//获取Agent回复,实现流式输出
export const getAgentResponseStream = async (message, chat_history, user_id, ifUseKnowldgeBase, ifUseWeb,systemPrompt) => {
  try {
    const response = await fetch(`${API_URL}/get_agent_response_stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message: message,
        chat_history: chat_history,
        user_id: user_id,
        ifUseKnowldgeBase: ifUseKnowldgeBase,
        ifUseWeb: ifUseWeb,
        systemPrompt: systemPrompt,
      })
    });
    return response;

    // if (!response.body) {
    //   throw new Error('Response body is not available');
    // }

    // const reader = response.body.getReader();
    // const decoder = new TextDecoder('utf-8');
    // let done = false;
    // while (!done) {
    //   const { done, value } = await reader.read();
    //   if (done) break;
    //   if(value)
    //   {
    //     //console.log('Received chunk:', decoder.decode(value));
    //     const chunk = decoder.decode(value);
    //     console.log('Received chunk:', decoder.decode(value));
    //     return chunk;
    //     // 处理接收到的分块数据
    //     // 例如，将其添加到一个数组中，或者直接输出到控制台
    //   }
      
    // }

  } catch (error) {
    console.error('Error during get Agent response:', error);
    throw error;
  }
};

//获取聊天记录
export const getChatHistory = async (user_id,chat_id) => {
  try {
    const response = await axios.get(`${API_URL}/chat_messages`, {
      params: { user_id:user_id,chat_id: chat_id }
    });
    console.log('Response:', response);
    return {messages:response.data.messages,scene:response.data.scene}; // 返回消息列表和场景
  } catch (error) {
    console.error('Error during get chat history:', error);
    throw error;
  }
};

//更新ai回复投票

export const updateVote = async (user_id, chat_id, timestamp, vote) => {
  try {
    const response = await axios.post(`${API_URL}/update_chat_vote`, {
      user_id: user_id,
      chat_id: chat_id,
      timestamp: timestamp,
      vote: vote
    });
    console.log('Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error during update vote:', error);
    throw error;
  }
};

//创建知识库文件夹
export const createkbFolder = async (user_id, folder_name) => {
  try {
    const response = await axios.post(`${API_URL}/create_kbfolder`, {
      user_id: user_id,
      folder_name: folder_name 
    })
    console.log('创建文件夹:', response);
  } catch (error) {
    console.error('Error during create folder:', error);
    throw error; 
  } 
};
//删除知识库文件夹
export const deletekbFolder = async (user_id, folder_name) => {
  try {
    const response = await axios.post(`${API_URL}/delete_kbfolder`, {
      user_id: user_id,
      folder_name: folder_name
    }); 
    console.log('删除文件夹', response);
  }  
  catch (error) {
    console.error('Error during delete folder:', error);
    throw error; 
  }
};

//获取知识库文件夹列表
export const getkbFolderList = async (user_id) => {
  try {
    const response = await axios.get(`${API_URL}/get_kbfolders`, {
      params: { user_id: user_id }
    });
    console.log('获取知识库文件夹列表:', response);
    return response;
  }  catch (error) {
    console.error('Error during get folder list:', error);
    throw error;
  }
}

//修改知识库文件夹名称
export const updatekbFolderName = async (user_id, old_folder_name, new_folder_name) => {
  try {
    const response = await axios.post(`${API_URL}/rename_kbfolder`, {
      user_id: user_id,
      old_folder_name: old_folder_name,
      new_folder_name: new_folder_name
    }); 
    console.log('修改文件夹名称:', response);
    return response;
  }
  catch (error) {
    console.error('Error during rename kbfolder:', error);
    throw error;
  }
}

//写入知识库配置文件
export const writekbConfig = async (user_id, folder_name, imgBase64,detail, splitToken,segmentIdentifier,overlap,titleSeparator,ifMarkdown,ifOCR) => {
  try {
    const response = await axios.post(`${API_URL}/write_kbconfig`, {
      user_id: user_id,
      folder_name: folder_name,
      config: {
        imgBase64: imgBase64,
        detail: detail,
        splitToken: splitToken,
        segmentIdentifier: segmentIdentifier,
        overlap:overlap,
        titleSeparator:titleSeparator,
        ifMarkdown:ifMarkdown,
        ifOCR:ifOCR,
        collection_name: folder_name // 添加 collectionName 字段
      }
    }); 
    console.log('写入知识库配置文件:', response);
  }
  catch (error) {
    console.error('Error during write kbconfig:', error);
    throw error; 
  }
}

//获取知识库配置文件
export const getkbConfig = async (user_id, folder_name) => {
  try {
    const response = await axios.get(`${API_URL}/read_kbconfig`, {
      params: { user_id: user_id, folder_name: folder_name }
    }); 
    console.log('获取知识库配置文件:', response);
    return response;
  }  
  catch (error) {
    console.error('Error during get kbconfig:', error);
    throw error; 
  }
}

// 上传知识库文件
export const uploadkbFile = async (user_id, folder_name, file) => {
  try {
    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('folder_name', folder_name);
    formData.append('file', file);
    const response = await axios.post(`${API_URL}/upload_kbfile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    console.log('上传知识库文件:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error during upload kbfile:', error);
    throw error;
  }
};

//写入知识库文件配置文件
export const writekbfileConfig = async (user_id, folder_name, file_name,config) => {
  try {
    const response = await axios.post(`${API_URL}/write_kbfileconfig`, {
      user_id: user_id,
      folder_name: folder_name,
      file_name: file_name,
      config: config
    }); 
    console.log('写入知识库配置文件:', response);
  }
  catch (error) {
    console.error('Error during write kbconfig:', error);
    throw error; 
  }
}

// 获取知识库文件夹下的所有文件
export const getKbFiles = async (user_id, folder_name) => {
  try {
    const response = await axios.get(`${API_URL}/get_kbfiles`, {
      params: {
        user_id,
        folder_name
      }
    });
    console.log('获取知识库文件夹下的所有文件:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error during getKbFolders:', error);
    throw error;
  }
};

//删除知识库文件
export const deleteKbFile = async (user_id, folder_name, file_name) => {
  try {
    const response = await axios.post(`${API_URL}/delete_kbfile`, {
      user_id,
      folder_name,
      file_name
    });
    console.log('文件删除成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error during deleteKbFile:', error);
    throw error;
  }
};

//修改知识库文件名称
export const updateKbFileName = async (user_id, folder_name, old_file_name, new_file_name) => {
  try {
    const response = await axios.post(`${API_URL}/rename_kbfile`, {
      user_id,
      folder_name,
      old_file_name,
      new_file_name
    });
    console.log('文件名称修改成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error during updateKbFileName:', error);
    throw error;
  }
};

//下载知识库文件
export const downloadKbFile = async (user_id, folder_name, file_name,file_type) => {
  try {
    const response = await axios.get(`${API_URL}/download_kbfile`, {
      params: {
        user_id,
        folder_name,
        file_name
      },
      responseType: 'blob' // 确保响应类型为 Blob
    });
    // 创建一个 Blob 对象
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    
    // 创建一个 URL 对象并将其指向 Blob
    const url = window.URL.createObjectURL(blob);
    
    // 创建一个隐藏的链接元素
    const link = document.createElement('a');
    link.href = url;
    if (file_type=='application/pdf')
      link.setAttribute('download', '下载文档.pdf'); // 设置下载文件名
    else if (file_type=='text/plain')
      link.setAttribute('download', '下载文档.txt'); // 设置下载文件名
    else if (file_type=='text/markdown')
      link.setAttribute('download', '下载文档.md'); // 设置下载文件名
    else
      link.setAttribute('download', '下载文档.pdf'); // 设置下载文件名
    
    // 将链接添加到文档并程序化地点击它以启动下载
    document.body.appendChild(link);
    link.click();
    
    // 移除链接元素
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error during downloadKbFile:', error);
    throw error;
  }
};



//查看知识库文件
export const viewKbFile = async (user_id, folder_name, file_name,file_type) => {
  try {
    const response = await axios.get(`${API_URL}/download_kbfile`, {
      params: {
        user_id,
        folder_name,
        file_name
      },
      responseType: 'blob' // 确保响应类型为 Blob
    });
    let blob;
     // 创建一个 Blob 对象
    if (file_type=='application/pdf')
       blob= new Blob([response.data], { type: 'application/pdf' });
    else if (file_type=='text/plain')
        blob= new Blob([response.data], { type: 'text/plain;charset=utf-8' });    
    else
        blob= new Blob([response.data], { type: 'application/pdf' });
     // 创建一个 URL 对象并将其指向 Blob
     const url = window.URL.createObjectURL(blob);
     // 打开新窗口或标签页以显示 PDF 文件
     window.open(url);
  } catch (error) {
    console.error('Error during viewKbFile:', error);
    throw error;
  }
};

//查看知识库文件
export const viewchunkFile = async (user_id, folder_name, file_name) => {
  try {
    const response = await axios.get(`${API_URL}/download_chunkfile`, {
      params: {
        user_id,
        folder_name,
        file_name
      },
      responseType: 'blob' // 确保响应类型为 Blob
    });
    let blob;
     // 创建一个 Blob 对象

    blob= new Blob([response.data], { type: 'text/plain;charset=utf-8' });    

     // 创建一个 URL 对象并将其指向 Blob
     const url = window.URL.createObjectURL(blob);
     // 打开新窗口或标签页以显示 PDF 文件
     window.open(url);
  } catch (error) {
    alert('无法正常读取分块，检查是否解析完毕!');
    console.error('Error during viewKbFile:', error);
    throw error;
  }
};
//创建知识库向量数据库
export const createVectorDB = async (userId, folderName, fileName, config,fileType) => {
  try {
    const response = await axios.post(`${API_URL}/create_vector_db`, {
      user_id: userId,
      folder_name: folderName,
      file_name: fileName,
      config: config,
      file_type: fileType
    });
    console.log('向量库创建成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('向量库创建失败:', error.response ? error.response.data : error.message);
  }
};

// 询问知识库的请求
export async function askVectorDB(userId, folderName, message) {
  try {
      const response = await axios.post(`${API_URL}/ask_vector_db`, {
          user_id: userId,
          folder_name: folderName,
          message: message
      });
      console.log('知识检索结果:',response.data);
      return response.data;
  } catch (error) {
      console.error('询问知识库失败:', error.response ? error.response.data : error.message);
  }
}

// ========== 用户余额和充值相关接口 ==========

//获取用户余额和使用情况
export const getUserBalance = async (user_id) => {
  try {
    const response = await axios.get(`${API_URL}/user_balance`, {
      params: { user_id: user_id }
    });
    console.log('获取用户余额:', response);
    return response.data;
  } catch (error) {
    console.error('Error during get user balance:', error);
    throw error;
  }
};

//获取充值套餐列表
export const getRechargePackages = async () => {
  try {
    const response = await axios.get(`${API_URL}/recharge_packages`);
    console.log('获取充值套餐:', response);
    return response.data;
  } catch (error) {
    console.error('Error during get recharge packages:', error);
    throw error;
  }
};

//创建充值订单
export const createRechargeOrder = async (user_id, package_id, payment_method) => {
  try {
    const response = await axios.post(`${API_URL}/create_recharge_order`, {
      user_id: user_id,
      package_id: package_id,
      payment_method: payment_method
    });
    console.log('创建充值订单:', response);
    const order= response.data.order  ;
    let order_data={
      payment_method: payment_method,  // 支付方式: wechat, alipay
      out_trade_no: order.order_id,  // 商户订单号
      total_fee: order.price.toString(),  // 支付金额
      body: order.package_name,  //商品描述
      notify_url: `${API_URL}/payment_callback`,  // 支付通知地址
      // attach: response.data.attach,  // 附加数据
      // time_expire: response.data.time_expire,  // 订单失效时间
    }
    const paymentResponse = await createLtzfPayment(payment_method, order_data);
    let output={};
    if(paymentResponse.code==0)
      output={
        order_id:order.order_id,
        qr_code_url:paymentResponse.data.QRcode_url
      }
    return output;
    
  } catch (error) {
    console.error('Error during create recharge order:', error);
    throw error;
  }
};

// 蓝兔支付统一创建订单接口
export const createLtzfPayment = async (payment_method, order_data) => {
  try {
      // 通过后端代理调用（推荐，避免CORS问题）
      const response = await axios.post(`${API_URL}/ltzf_payment_proxy`, order_data);
      console.log(`蓝兔支付代理-${payment_method}:`, response);
      return response.data;

  } catch (error) {
    console.error('Error during ltzf payment:', error);
    throw error;
  }
};


//获取用户使用记录
export const getUserUsageHistory = async (user_id, start_date, end_date, page = 1, page_size = 20) => {
  try {
    const response = await axios.get(`${API_URL}/user_usage_history`, {
      params: { 
        user_id: user_id,
        start_date: start_date,
        end_date: end_date,
        page: page,
        page_size: page_size
      }
    });
    console.log('获取用户使用记录:', response);
    return response.data;
  } catch (error) {
    console.error('Error during get user usage history:', error);
    throw error;
  }
};

//获取用户购买记录
export const getUserPurchaseHistory = async (user_id, start_date, end_date, page = 1, page_size = 20) => {
  try {
    const response = await axios.get(`${API_URL}/user_purchase_history`, {
      params: { 
        user_id: user_id,
        start_date: start_date,
        end_date: end_date,
        page: page,
        page_size: page_size
      }
    });
    console.log('获取用户购买记录:', response);
    return response.data;
  } catch (error) {
    console.error('Error during get user purchase history:', error);
    throw error;
  }
};

//扣减用户tokens
export const deductUserTokens = async (user_id, tokens, usage_type, description) => {
  try {
    const response = await axios.post(`${API_URL}/deduct_tokens`, {
      user_id: user_id,
      tokens: tokens,
      usage_type: usage_type,
      description: description
    });
    console.log('扣减用户tokens:', response);
    return response.data;
  } catch (error) {
    console.error('Error during deduct tokens:', error);
    throw error;
  }
};

//支付回调处理
export const handlePaymentCallback = async (order_id, payment_status, transaction_id) => {
  try {
    const response = await axios.post(`${API_URL}/payment_callback`, {
      order_id: order_id,
      payment_status: payment_status,
      transaction_id: transaction_id
    });
    console.log('支付回调处理:', response);
    return response.data;
  } catch (error) {
    console.error('Error during payment callback:', error);
    throw error;
  }
};

//查询订单状态
export const getOrderStatus = async (order_id) => {
  try {
    const response = await axios.get(`${API_URL}/order_status`, {
      params: { order_id: order_id }
    });
    console.log('查询订单状态:', response);
    return response.data;
  } catch (error) {
    console.error('Error during get order status:', error);
    throw error;
  }
};

//取消订单（通过支付回调处理）
export const cancelOrder = async (order_id) => {
  try {
    const response = await handlePaymentCallback(order_id, "cancelled", null);
    console.log('取消订单:', response);
    return response;
  } catch (error) {
    console.error('Error during cancel order:', error);
    throw error;
  }
};








